import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "edit-box",
  ref: "box"
}
const _hoisted_2 = { class: "edit-item" }
const _hoisted_3 = {
  key: 0,
  class: "edit-item"
}
const _hoisted_4 = {
  key: 1,
  class: "edit-item"
}
const _hoisted_5 = {
  key: 2,
  class: "edit-item"
}
const _hoisted_6 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelConfig && _ctx.cancelConfig(...args)))
  }, [
    _createElementVNode("div", {
      class: "center",
      onClick: _cache[6] || (_cache[6] = ($event: any) => ($event.stopPropagation()))
    }, [
      _cache[12] || (_cache[12] = _createElementVNode("h4", null, "内容编辑器", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "名称", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.content.name]
          ]),
          _createVNode(_component_SvgIcon, {
            name: "Copy",
            size: "24px",
            onClick: _ctx.copyContent
          }, null, 8, ["onClick"])
        ]),
        ('url' in _ctx.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "链接", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                name: "url",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content.url) = $event))
              }, null, 512), [
                [_vModelText, _ctx.content.url]
              ]),
              _createVNode(_component_SvgIcon, {
                name: "Copy",
                size: "24px",
                onClick: _ctx.copyContent
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        ('icon' in _ctx.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "图标", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                name: "icon",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.content.icon) = $event))
              }, null, 512), [
                [_vModelText, _ctx.content.icon]
              ]),
              _createVNode(_component_SvgIcon, {
                name: "Copy",
                size: "24px",
                onClick: _ctx.copyContent
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        ('color' in _ctx.content)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "颜色", -1)),
              _withDirectives(_createElementVNode("input", {
                tabindex: "3",
                type: "text",
                name: "color",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content.color) = $event))
              }, null, 512), [
                [_vModelText, _ctx.content.color]
              ]),
              _createVNode(_component_SvgIcon, {
                name: "Copy",
                size: "24px",
                onClick: _ctx.copyContent
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelConfig && _ctx.cancelConfig(...args)))
        }, "取消"),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirmConfig && _ctx.confirmConfig(...args)))
        }, "确定")
      ])
    ])
  ]))
}